import React, {useContext, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {
    Button,
    Grid,
    GridColumn,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Select,
    TextField, TMultipleSelectValue,
} from '../../../patterns';
import {StoreContext} from '../base/root-store';

export const AddAndEditDepartmentModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).companyStore;
    const initialBusinessUnit = store.variables.departmentInEditing;
    const initialBusinessUnitManagerId = initialBusinessUnit && initialBusinessUnit.managerId ? initialBusinessUnit.managerId : 'no-manager';

    const [parentBusinessUnitId, setParentBusinessUnitId] = useState<string | undefined >(initialBusinessUnit ? initialBusinessUnit.parentBusinessUnitId : store.payload!.rootOneBusinessUnit.id);
    const [businessUnitName, setBusinessUnitName] = useState<string>(initialBusinessUnit ? initialBusinessUnit.businessUnitName : '');
    const [managerId, setManagerId] = useState<string>(initialBusinessUnitManagerId);
    const [partners, setPartners] = useState<TMultipleSelectValue | undefined>(initialBusinessUnit?.partners);

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.variables.openModal==='add-department' ? store.label('company.department-modal.title-add') : store.label('company.department-modal.title-edit')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">
                    <Select
                        label={store.label('company.department-modal.parent-business-unit')}
                        defaultValue={parentBusinessUnitId}
                        onChange={(value): void => setParentBusinessUnitId('' + value)}
                        options={initialBusinessUnit !== undefined ? store.getEligibleParentBusinessUnits(initialBusinessUnit).map((businessUnit) => ({
                            label: businessUnit.businessUnitName,
                            value: businessUnit.id,
                        })).sort((a,b) => a.label.localeCompare(b.label)) : store.getBusinessUnits().map((businessUnit) => ({
                            label: businessUnit.businessUnitName,
                            value: businessUnit.id,
                        })).sort((a,b) => a.label.localeCompare(b.label)) }
                        search={{
                            label: store.label('company.department-modal.search-department'),
                            id: 'add-parent-department-search',
                            name: 'add-parent-department-search',
                        }}
                        id='add-parent-department'
                        name='add-parent-department'
                        type={undefined}
                    />
                    <TextField
                        label={store.label('company.department-modal.insert-business-unit')}
                        focusLabel={initialBusinessUnit ? store.label('company.department-modal.edit-business-unit-name'): store.label('company.department-modal.insert-business-unit')}
                        defaultValue={businessUnitName}
                        onChange={((value): void => setBusinessUnitName(value))}
                        id='add-business-unit-name'
                        name='add-business-unit-name'
                        description={store.variables.showValidation && store.getNameError(businessUnitName, 'unit_name_forbidden') !== undefined ? store.label(`common.validation.${store.getNameError(businessUnitName, 'unit_name_forbidden')}`) : undefined}
                        invalid={store.variables.showValidation && store.getNameError(businessUnitName, 'unit_name_forbidden') !== undefined}
                    />
                    <Select
                        label={store.label('company.department-modal.select-manager')}
                        defaultValue={managerId}
                        onChange={(value): void => setManagerId('' + value)}
                        options={[
                            {
                                label: store.label('company.department-modal.no-manager'),
                                value: 'no-manager',
                            },
                            ...store.payload!.allEmployeesPayload.allEmployees.map((employee) => ({
                                label: employee.employeeFirstName.concat(' '+ employee.employeeLastName),
                                value: employee.employeeId,
                            })).sort((a,b) => a.label.localeCompare(b.label))]}
                        search={{
                            label: store.label('company.department-modal.search-manager'),
                            id: 'add-employee-search',
                            name: 'add-employee-search',
                        }}
                        id='add-employee-name'
                        name='add-employee-name'
                        type={undefined}
                    />
                    <Select
                        label={store.label('menu.business-units-partners')}
                        defaultValue={partners}
                        onChange={(value): void => setPartners(value)}
                        options={[
                            ...store.payload!.allEmployeesPayload.allEmployees.map((employee) => ({
                                label: employee.employeeFirstName.concat(' ' + employee.employeeLastName),
                                value: employee.employeeId,
                            })).sort((a, b) => a.label.localeCompare(b.label)),
                        ]}
                        search={{
                            label: store.label('company.department-modal.search-manager'),
                            id: 'add-manager-right-employee-name',
                            name: 'add-manager-right-employee-name',
                        }}
                        id="add-manager-right-employee-name"
                        name="add-manager-right-employee-name"
                        type="multiple"
                    />
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['between-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('company.modal.cancel')}/>
                        </ModalCloser>
                    </GridColumn>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <Button block={true} text={store.label('company.modal.save')}
                            onClick={(): void => store.saveDepartment({
                                parentBusinessUnitId,
                                businessUnitName,
                                managerId: managerId === 'no-manager' ? undefined : managerId,
                                partners,
                            })}/>
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
